<section class="d-flex flex-column w-100">
  <sm-user-data></sm-user-data>
  <sm-user-credentials></sm-user-credentials>
</section>
